<template>
  <label class="checkbox-label" :class="isMobile() ? 'mobile-label' : ''">
    {{ label }}
    <input
      type="checkbox"
      :value="inputValue"
      v-model="model"
      :disabled="disabled"
    />
    <span class="checkbox-checkmark" :style="getStyle()"></span>
  </label>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    label: {
      type: String,
      default: "label",
    },
    value: Array,
    inputValue: Object,
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  mounted: function () {
    this.$el.indeterminate = true;
  },
  computed: {
    ...mapGetters(["desktopStyles", "mobileStyles"]),
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    getStyle() {
      var style = [];
      if (this.value.includes(this.inputValue)) {
        style.push(
          this.isMobile()
            ? this.mobileStyles.CommonColorBackground
            : this.desktopStyles.CommonColorBackground
        );
      } else {
        style.push(
          this.isMobile()
            ? this.mobileStyles.pendingStatusBackground
            : this.desktopStyles.pendingStatusBackground
        );
      }
      return style;
    },
  },
};
</script>
